<template>
  <div class="component-content sub-content">
    <div class="project-detail" v-if="contract">
      <h1>
        <div class="r">
          <el-button
            @click="projectStatusUpdateCancle()"
            size="small"
            v-if="backRole('CT_5')"
            type="danger"
            >废弃该合同
          </el-button>
          <el-button
            @click="deleteContract()"
            size="small"
            v-if="contract.status == '新建完成' && isLeader"
            type="danger"
          >
            删除合同</el-button
          >
        </div>
        <span class="approval-type at3">{{ typeName[contract.type] }}</span
        >{{ contract.name }}
        <router-link v-if="isLeader" :to="'/Contract/Edit/' + contract.id">
          <el-button
            type="warning"
            class="h1-edit"
            icon="el-icon-edit"
            circle
          ></el-button>
        </router-link>
        <span class="status">当前状态：{{ contract.status }}</span>
      </h1>
      <div
        class="intro"
        v-html="
          contract.outline &&
            contract.outline.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>')
        "
      ></div>
      <div class="info">
        <div class="info-content" v-if="contract.projectNames">
          <div class="info-item" style="width: 100%">
            <label>相关工程：</label>
            <span class="cont">{{ contract.projectNames }}</span>
            <a href="javascript:void(0)" @click="tabItem = '2'"
              >（点击查看详情）</a
            >
          </div>
        </div>

        <div class="info-content" v-if="contract.purchaseNames">
          <div class="info-item" style="width: 100%">
            <label>关联采购：</label>
            <span class="cont">{{ contract.purchaseNames }}</span>
            <a href="javascript:void(0)" @click="tabItem = '3'"
              >（点击查看详情）</a
            >
          </div>
        </div>

        <div class="info-content">
          <div class="info-item">
            <label>所属公司：</label>
            <span class="cont">{{ contract.departmentVO.name }}</span>
          </div>
          <div class="info-item">
            <label>合同创建者：</label>
            <span class="cont">{{
              contract.creator.name +
                "/" +
                (contract.creator.telephone
                  ? contract.creator.telephone
                  : contract.creator.mobile)
            }}</span>
          </div>
        </div>
        <div class="info-content">
          <div class="info-item info-item2">
            <label>合同负责人：</label>
            <span class="cont">{{
              contract.leader.name +
                "/" +
                (contract.leader.telephone
                  ? contract.leader.telephone
                  : contract.leader.mobile)
            }}</span>
            <el-button
              v-if="isLeader"
              @click="addUsers(1)"
              style="margin-left: 10px"
              round
              size="mini"
              type="primary"
            >
              更换</el-button
            >
          </div>
        </div>
        <div class="info-content">
          <div class="info-item info-item2">
            <label>进度款审核负责人：</label>
            <span class="cont">{{
              contract.kxLeader
                ? contract.kxLeader.name + " / " + contract.kxLeader.telephone
                : "未设置"
            }}</span>
            <el-button
              v-if="isLeader"
              @click="addUsers(2)"
              style="margin-left: 10px"
              round
              size="mini"
              type="primary"
            >
              更换</el-button
            >
          </div>
        </div>
      </div>

      <div v-if="isLeader" class="object-tool" style="margin-bottom: 20px">
        <router-link
          v-if="
            contract.isZb &&
              (contract.status == '招标完成' ||
                contract.status == '签订中' ||
                contract.status == '实施中')
          "
          :to="'/Contract/InviteResult/' + contract.id"
        >
          <el-button size="small" type="warning"
            >编辑招标情况填录(开标结果)</el-button
          >
        </router-link>
      </div>

      <!-- 验收登记 -->
      <div class="dengji-box" v-if="ysInfo.yssj">
        <h3 class="title">
          项目验收登记
          <router-link
            v-if="isLeader"
            :to="'/Contract/CreateEnd/' + contract.id"
          >
            <el-button
              size="mini"
              style="margin-left: 10px"
              type="success"
              plain
              >编辑</el-button
            >
          </router-link>
        </h3>
        <div class="dj-content">
          <div class="dj-item">
            <label>验收时间：</label>
            <div class="dj-value">{{ ysInfo.yssj }}</div>
          </div>
          <div class="dj-item">
            <label>验收情况说明：</label>
            <div class="dj-value">{{ ysInfo.ysqksm }}</div>
          </div>
        </div>
      </div>
      <!-- <router-link :to="'/Contract/CreateMoneyApproval/'+contract.id">
        <el-button size="small" type="success" plain>合同付款审核意见单</el-button>
      </router-link> -->
      <!-- 合同操作 -->
      <div class="object-tool" v-if="isKxLeader">
        <div class="wait-tip" v-if="waitMessage">{{ waitMessage }}</div>
        <div class="next-worker" v-else>
          <h3 class="title">接下来您可以</h3>
          <div class="btn-room">
            <router-link :to="'/Contract/CreateMoneyApproval/' + contract.id">
              <el-button size="small" type="success" plain
                >合同付款审核意见单</el-button
              >
            </router-link>
          </div>
        </div>
      </div>
      <div class="object-tool" v-if="isLeader">
        <div class="wait-tip" v-if="waitMessage">{{ waitMessage }}</div>
        <div class="next-worker" v-else>
          <h3 class="title">接下来您可以</h3>
          <div class="btn-room">
            <!-- 合同招标 -->
            <div
              v-if="
                contract.isZb &&
                  (contract.status == '新建完成' || contract.status == '招标中')
              "
            >
              <p class="tip">
                注：招标情况填录(开标结果)登记后，将进入合同签订环节。
              </p>
              <router-link
                :to="'/Contract/CreateInviteApproval/' + contract.id"
              >
                <el-button size="small" type="success" plain
                  >招标文件审核会签表</el-button
                >
              </router-link>
              <router-link :to="'/Contract/InviteResult/' + contract.id">
                <el-button size="small" type="primary"
                  >招标情况填录(开标结果)</el-button
                >
              </router-link>
            </div>

            <!-- {{ overview.inviteSignflows }} -->
            <!-- 项目招标审批表补录 -->
            <div
              style="display: inline"
              v-if="
                (!overview.inviteSignflows ||
                  !overview.inviteSignflows.length) &&
                  contract.isZb &&
                  contract.status != '申请完成' &&
                  contract.status != '新建完成' &&
                  contract.status != '立项完成' &&
                  contract.status != '招标中'
              "
            >
              <router-link
                v-if="
                  !overview.inviteSignflows || !overview.inviteSignflows.length
                "
                :to="'/Contract/CreateInviteApproval/' + contract.id"
              >
                <el-button size="small" type="success" plain
                  >招标文件审核会签表</el-button
                >
              </router-link>
            </div>

            <div
              style="display: inline"
              v-if="
                (contract.type == '3' || contract.type == '4') &&
                  contract.status == '申请完成'
              "
            >
              <router-link :to="'/Project/CreateBudget/' + contract.id">
                <el-button size="small" type="success" plain
                  >预算（招标控制价）审批</el-button
                >
              </router-link>
            </div>

            <!-- 合同 -->
            <div
              style="display: inline"
              v-if="
                overview &&
                  ((!contract.isZb && contract.status == '新建完成') ||
                    (contract.isZb && contract.status == '招标完成') ||
                    contract.status == '签订中' ||
                    contract.status == '签订完成' ||
                    contract.status == '实施中' ||
                    contract.status == '验收完成')
              "
            >
              <router-link
                v-if="!overview.contractSignflows.length > 0"
                :to="'/Contract/CreateContractApproval/' + contract.id"
              >
                <el-button size="small" type="success" plain
                  >合同会签审批表</el-button
                >
              </router-link>
              <p
                style="padding: 10px 0"
                v-else-if="contract.status == '签订中'"
              >
                请等待合同会签完成...
              </p>

              <router-link
                v-if="!overview.contractRecordflows.length > 0"
                :to="'/Contract/CreateContractRecordApproval/' + contract.id"
              >
                <el-button size="small" type="success" plain
                  >合同备案审批表</el-button
                >
              </router-link>
            </div>

            <div
              style="display: inline"
              v-if="
                contract.status == '签订中' ||
                  contract.status == '签订完成' ||
                  contract.status == '实施中' ||
                  contract.status == '验收完成' ||
                  contract.status == '已完成'
              "
            >
              <router-link
                v-if="!ysInfo.yssj"
                :to="'/Contract/CreateEnd/' + contract.id"
              >
                <el-button size="small" type="primary">合同验收登记</el-button>
              </router-link>

              <router-link :to="'/Contract/CreatePayApproval/' + contract.id">
                <el-button size="small" type="success" plain
                  >合同款项支付审批</el-button
                >
              </router-link>
            </div>

            <!-- <div
              v-if="contract.status=='签订中' || contract.status == '签订完成' || contract.status == '实施中' || contract.status == '已完成'"
              class="project-tool-box" style="display:inline;">

            </div> -->
          </div>
        </div>
      </div>
    </div>

    <el-tabs class="project-tabs" v-model="tabItem" type="border-card">
      <el-tab-pane label="审批详情">
        <info
          :isLeader="isLeader"
          :isKxLeader="isKxLeader"
          :isContract="true"
          :project="overview"
          v-if="'0' === tabItem"
        ></info>
      </el-tab-pane>
      <el-tab-pane label="相关文档">
        <file
          :isLeader="isLeader"
          :contractId="contractId"
          v-if="'1' === tabItem"
        ></file>
      </el-tab-pane>
      <el-tab-pane label="相关工程">
        <project-list
          :isLeader="isLeader"
          :contractId="contractId"
          v-if="'2' === tabItem"
        ></project-list>
      </el-tab-pane>
      <el-tab-pane label="关联采购">
        <purchase-list
          :isLeader="isLeader"
          :contractId="contractId"
          v-if="'3' === tabItem"
        ></purchase-list>
      </el-tab-pane>
    </el-tabs>

    <project-info></project-info>
  </div>
</template>
<script>
import { mapState } from "vuex";

import Role from "@/Mixins/role";
import Info from "../project/info";
import projectInfo from "../user/projectInfo";
// import Approval from '../project/approval'
import File from "./file";
import ProjectList from "./projectlist";
import PurchaseList from "./purchaseList";

export default {
  components: {
    projectInfo,
    Info,
    File,
    ProjectList,
    PurchaseList
  },
  computed: {
    ...mapState({
      contactSelectArr: state => state.main.contactSelectArr,
      userData: state => state.main.userData,
      projectReload: state => state.main.projectReload
    })
  },
  mixins: [Role],
  data() {
    return {
      // typeName
      typeName: ["独立合同", "工程合同", "子合同合同"],
      // tab
      tabItem: "0",

      // 验收登记
      ysInfo: "",

      // 合同对象
      contractId: "",
      contract: "",

      // 选择更换合同负责人
      leaderType: 1,
      selectArr: [],
      // 是否有编辑权限
      isLeader: false,
      // 是否有款项负责人权限
      isKxLeader: false,

      // 等待提示消息
      waitMessage: "",

      // 审批表
      overview: ""
    };
  },
  created() {
    this.contractId = this.$route.params.id;
    this.getContactDetail();
    this.getYsInfo();
  },
  methods: {
    // 验收登记
    getYsInfo() {
      ajax.get("/contract/ys/info/" + this.contractId, "", res => {
        this.ysInfo = res.vo ? res.vo : "";
      });
    },
    // 设置合同招标结束
    projectStatusUpdateZB(typeText) {
      this.$confirm(
        "该操作将直接设置合同状态为『" +
          typeText +
          "』，设置后，将跳过『" +
          typeText +
          "』前所有步骤，直接进入下一个流程，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.projectStatusUpdate(typeText);
        })
        .catch(() => {});
    },
    // 设置状态状态
    projectStatusUpdate(statusText) {
      // console.log(111333)
      ajax.post(
        "/contract/status/update",
        {
          contractId: this.contractId,
          status: statusText
        },
        res => {
          this.$message.success("设置" + statusText + "成功");
          this.getContactDetail();
        }
      );
    },
    // 设置合同废弃
    projectStatusUpdateCancle() {
      this.$router.push({
        path: "/Contract/CreateDiscard",
        query: {
          // applyId: row.flow.applyId,
          contractId: this.contract.id
        }
      });
    },
    // 删除合同
    deleteContract() {
      this.$confirm("此操作将永久删除该合同, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ajax.post(
            "/contract/del",
            {
              contractId: this.contractId
            },
            res => {
              this.$message.error("删除合同成功");
              // 返回列表
              this.$router.push("/Contract/List");
            }
          );
        })
        .catch(() => {});
    },
    // 获取合同详情
    getContactDetail() {
      ajax.get("/contract/info/" + this.contractId, "", res => {
        this.contract = res.vo;

        if (
          this.contract.leader.id == this.userData.id ||
          this.contract.creator.id == this.userData.id
        ) {
          this.isLeader = true;
        }
        // this.isLeader = this.contract.leader.id == this.userData.id
        if (this.contract.kxLeader) {
          this.isKxLeader = this.contract.kxLeader.id == this.userData.id;
        }

        // title
        document.title = this.contract.name + " - 象山水务集团";
      });
      ajax.get("/contract/overview/" + this.contractId, "", res => {
        this.overview = res.vo;
      });
    },

    // 选择更换合同/款项负责人
    addUsers(type) {
      this.leaderType = type;
      let _sr = [];
      switch (type) {
        case 1:
          _sr.push(this.contract.leader);
          break;
        case 2:
          if (this.contract.kxLeader) {
            _sr.push(this.contract.kxLeader);
          }
          break;
      }
      this.$store.commit("set_contactSelectArr", _sr);
      this.$store.commit("set_contactShow", true);
      this.$store.commit("set_contactSingleSelect", true);
    },
    // 更换合同负责人
    leaderUpdate() {
      console.log(this.selectArr);
      if (this.selectArr.length < 1) {
        return;
      }
      this.$confirm(
        "你确定要将合同管理权限转移至" +
          this.selectArr[0].name +
          "? 此操作将使你失去合同的管理权限。",
        "更换合同负责人",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          ajax.post(
            "/contract/leader/update",
            {
              contractId: this.contract.id,
              userId: this.selectArr[0].id
            },
            res => {
              this.getContactDetail();
            }
          );
        })
        .catch(() => {});
    },
    // 更换款项负责人
    kxLeaderUpdate() {
      console.log(this.selectArr);
      if (this.selectArr.length < 1) {
        return;
      }
      this.$confirm(
        "你确定要将合同进度款审核管理权限转移至" +
          this.selectArr[0].name +
          "? ",
        "更换款项负责人",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          ajax.post(
            "/contract/kx/leader/update",
            {
              contractId: this.contract.id,
              userId: this.selectArr[0].id
            },
            res => {
              this.getContactDetail();
            }
          );
        })
        .catch(() => {});
    }
  },

  watch: {
    contactSelectArr() {
      console.log(this.contract);
      if (this.contactSelectArr.length < 1 || this.contactType) {
        return;
      }
      this.selectArr = this.contactSelectArr;
      if (
        this.contactSelectArr[0].id != this.contract.leader.id &&
        this.leaderType == 1
      ) {
        this.leaderUpdate();
      }
      if (this.leaderType == 2) {
        if (
          this.contract.kxLeader &&
          this.contactSelectArr[0].id != this.contract.kxLeader.id
        ) {
          this.kxLeaderUpdate();
        }
        if (!this.contract.kxLeader) {
          this.kxLeaderUpdate();
        }
      }
    },
    $route(to, from) {
      this.projectId = this.$route.params.id;
      this.getContactDetail();
      this.tabItem = "0";
    },
    projectReload() {
      if (this.projectReload) {
        this.getContactDetail();
        this.$store.commit("set_projectReload", false);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/contract/detail.vue